import React from 'react';
import c from '../w.js';

const IconMinus = React.memo(
  c(/* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 11H20V13H4V11Z" }))
);

export { IconMinus };
